// extracted by mini-css-extract-plugin
export default {"profile":"TableProfile_profile__qYlyf"};